module.exports = "/assets/src/client/assets/topLevelPage/styled-KoLogo.svg";